import { ref, reactive } from 'vue'

export function useNumericKeypad() {
  const isVisible = ref(false)
  
  const keypadConfig = reactive({
    title: '',
    subtitle: '',
    mode: 'number', // 'number', 'currency', 'decimal'
    initialValue: '',
    confirmText: 'Confirm',
    maxValue: null,
    minValue: 0,
    maxDigits: 10,
    showQuickAmounts: true,
    onConfirm: null,
    onCancel: null
  })

  const openKeypad = (config = {}) => {
    // Reset configuration
    Object.assign(keypadConfig, {
      title: '',
      subtitle: '',
      mode: 'number',
      initialValue: '',
      confirmText: 'Confirm',
      maxValue: null,
      minValue: 0,
      maxDigits: 10,
      showQuickAmounts: true,
      onConfirm: null,
      onCancel: null,
      ...config
    })
    
    isVisible.value = true
  }

  const closeKeypad = () => {
    isVisible.value = false
  }

  const handleConfirm = (value) => {
    if (keypadConfig.onConfirm) {
      keypadConfig.onConfirm(value)
    }
    closeKeypad()
  }

  const handleCancel = () => {
    if (keypadConfig.onCancel) {
      keypadConfig.onCancel()
    }
    closeKeypad()
  }

  // Predefined keypad configurations
  const openQuantityKeypad = (initialValue = '', onConfirm = null) => {
    openKeypad({
      title: 'Enter Quantity',
      subtitle: 'How many items?',
      mode: 'number',
      initialValue,
      confirmText: 'Add to Cart',
      maxValue: 9999,
      minValue: 1,
      maxDigits: 4,
      showQuickAmounts: false,
      onConfirm
    })
  }

  const openPriceKeypad = (initialValue = '', onConfirm = null) => {
    openKeypad({
      title: 'Enter Price',
      subtitle: 'Set item price',
      mode: 'currency',
      initialValue,
      confirmText: 'Set Price',
      maxValue: 999999,
      minValue: 0.01,
      maxDigits: 8,
      showQuickAmounts: false,
      onConfirm
    })
  }

  const openDiscountKeypad = (initialValue = '', onConfirm = null) => {
    openKeypad({
      title: 'Enter Discount',
      subtitle: 'Discount percentage',
      mode: 'decimal',
      initialValue,
      confirmText: 'Apply Discount',
      maxValue: 100,
      minValue: 0,
      maxDigits: 5,
      showQuickAmounts: false,
      onConfirm
    })
  }

  const openPaymentKeypad = (initialValue = '', onConfirm = null) => {
    openKeypad({
      title: 'Enter Payment Amount',
      subtitle: 'Cash received',
      mode: 'currency',
      initialValue,
      confirmText: 'Process Payment',
      maxValue: 999999,
      minValue: 0,
      maxDigits: 8,
      showQuickAmounts: true,
      onConfirm
    })
  }

  const openCustomKeypad = (title, config = {}) => {
    openKeypad({
      title,
      ...config
    })
  }

  return {
    isVisible,
    keypadConfig,
    openKeypad,
    closeKeypad,
    handleConfirm,
    handleCancel,
    openQuantityKeypad,
    openPriceKeypad,
    openDiscountKeypad,
    openPaymentKeypad,
    openCustomKeypad
  }
}

export default useNumericKeypad